import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import registrationsAction from "../../../../../store/registrations/action";
import { RegisWizardSteps } from "../../../Helpers/LookUpValues";
import RegistrationQuestions from "../RegistrationQuestions";

class StepTwo extends Component {
  render() {
    let idx = this.props.steps.findIndex(
      (i) => i.key == RegisWizardSteps.SecondStep
    );
    const { currentStep, isDisabled, isPendingPaymentByTarget } = this.props;
    if (currentStep !== idx) {
      // Prop: The current step
      return null;
    }
    return (
      <>
        {isDisabled && isPendingPaymentByTarget && (
          <div className="alert alert-secondary mb-3 d-flex align-items-center">
            <i className="fa fa-lock mr-2"></i>
            <div>
              <strong>Questions answered by administrator</strong>
              <p className="mb-0 small">Review the responses below before proceeding to payment.</p>
            </div>
          </div>
        )}
        <RegistrationQuestions
          erros={this.props.errors}
          setValues={this.props.setValues}
          values={this.props.values}
          questions={this.props.registrationsState.selectedOpenRegQuestions}
          isDisabled={isDisabled}
        />
      </>
    );
  }
}
export default withRouter(
  connect(
    (state) => ({
      registrationsState: state.registrations,
    }),
    {
      ...registrationsAction,
    }
  )(StepTwo)
);
